/**
 * FileWriteCard — Write / Edit 工具结果的结构化渲染。
 * 显示文件图标 + 文件名 + 路径 + 操作标签。
 */

import { memo } from 'react'
import { FileText, FilePlus2, FilePen } from 'lucide-react'
import './result-cards.less'

interface FileWriteCardProps {
  fileName: string
  filePath: string
  action: 'created' | 'modified'
  detail?: string
}

const ACTION_LABELS: Record<string, string> = {
  created: '新建',
  modified: '已修改',
}

export const FileWriteCard = memo(function FileWriteCard({
  fileName,
  filePath,
  action,
  detail,
}: FileWriteCardProps) {
  const Icon = action === 'created' ? FilePlus2 : FilePen
  const statusClass = action === 'created' ? 'result-card--success' : ''

  return (
    <div className={`result-card ${statusClass}`}>
      <div className="result-card__field">
        <Icon className="result-card__field-icon" />
        <span className="result-card__field-value" style={{ fontWeight: 500 }}>
          {fileName}
        </span>
        <span
          className="text-[0.6rem] px-1.5 py-0.5 rounded-sm"
          style={{
            background: action === 'created'
              ? 'oklch(0.60 0.18 155 / 0.12)'
              : 'oklch(0.65 0.17 65 / 0.12)',
            color: action === 'created'
              ? 'oklch(0.45 0.15 155)'
              : 'oklch(0.50 0.14 65)',
          }}
        >
          {ACTION_LABELS[action]}
        </span>
      </div>
      <div className="result-card__field">
        <FileText className="result-card__field-icon" style={{ opacity: 0 }} />
        <span className="text-[0.65rem]" style={{ color: 'oklch(var(--muted-foreground) / 0.45)' }}>
          {filePath}
        </span>
      </div>
      {detail && (
        <div className="result-card__code-wrap">
          <pre className="result-card__code" style={{ maxHeight: '120px' }}>{detail}</pre>
        </div>
      )}
    </div>
  )
})
